(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sixth-hero-presale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sixth-hero-slideshow')) {
    customElements.define('sixth-hero-slideshow', class extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.autoplayTimer = null;
        this.isHovered = false;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchEndX = 0;
        this.touchEndY = 0;
        this._onVisibility = this._onVisibility.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.six-slide'));
        this.dots = Array.from(this.querySelectorAll('.six-slideshow-dot'));
        this.arrows = Array.from(this.querySelectorAll('.six-slideshow-arrow'));
        this.track = this.querySelector('[data-track]');
        this.blockCount = parseInt(this.dataset.blockCount, 10) || this.slides.length;
        this.transition = this.dataset.transition || 'fade';
        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = (parseFloat(this.dataset.autoplaySpeed) || 6) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this._setupReveal();

        if (this.blockCount <= 1) return;

        this.arrows.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.dataset.direction === 'next') this.next();
            else this.prev();
            this._resetAutoplay();
          });
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.index, 10);
            this.goTo(idx);
            this._resetAutoplay();
          });
        });

        this.addEventListener('mouseenter', () => { this.isHovered = true; this.stopAutoplay(); });
        this.addEventListener('mouseleave', () => { this.isHovered = false; this.startAutoplay(); });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => { if (!this.isHovered) this.startAutoplay(); });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); this._resetAutoplay(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this._resetAutoplay(); }
        });

        this.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        this.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          const diffX = this.touchStartX - this.touchEndX;
          const diffY = this.touchStartY - this.touchEndY;
          if (Math.abs(diffY) > Math.abs(diffX)) return;
          if (Math.abs(diffX) > 50) {
            if (diffX > 0) this.next(); else this.prev();
            this._resetAutoplay();
          }
        }, { passive: true });

        document.addEventListener('visibilitychange', this._onVisibility);

        if (this.transition === 'slide') this._updateOffset();

        if (this.autoplay && !this.reducedMotion) this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this._onVisibility);
      }

      _onVisibility() {
        if (document.hidden) this.stopAutoplay();
        else if (this.autoplay && !this.reducedMotion && !this.isHovered) this.startAutoplay();
      }

      next() {
        let next = this.currentIndex + 1;
        if (next >= this.blockCount) {
          if (this.loop) next = 0;
          else return;
        }
        this.goTo(next);
      }

      prev() {
        let prev = this.currentIndex - 1;
        if (prev < 0) {
          if (this.loop) prev = this.blockCount - 1;
          else return;
        }
        this.goTo(prev);
      }

      goTo(index) {
        if (index < 0 || index >= this.blockCount) return;
        this.currentIndex = index;

        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        const newSlide = this.slides[index];
        if (newSlide && !newSlide.classList.contains('is-revealed')) {
          this._revealSlide(newSlide);
        }

        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (this.transition === 'slide') this._updateOffset();
      }

      _updateOffset() {
        if (!this.track) return;
        this.track.style.setProperty('--offset', `-${this.currentIndex * 100}%`);
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion || this.blockCount <= 1) return;
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      _resetAutoplay() {
        if (this.autoplay && !this.reducedMotion && !this.isHovered) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      _setupReveal() {
        if (this.reducedMotion) {
          this.slides.forEach((s) => {
            s.classList.add('is-revealed');
            this._fillCounters(s);
          });
          return;
        }

        const firstSlide = this.slides[0];
        if (firstSlide) {
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs) => {
              entries.forEach((e) => {
                if (e.isIntersecting) {
                  this._revealSlide(e.target);
                  obs.unobserve(e.target);
                }
              });
            }, { threshold: 0.2 });
            io.observe(firstSlide);
          } else {
            this._revealSlide(firstSlide);
          }
        }
      }

      _revealSlide(slide) {
        slide.classList.add('is-revealed');
        const flips = slide.querySelectorAll('.six-flip[data-target]');
        flips.forEach((c) => this._animateFlipCounter(c));
      }

      _fillCounters(slide) {
        slide.querySelectorAll('.six-flip[data-target]').forEach((c) => {
          const target = parseInt(c.dataset.target, 10) || 0;
          c.innerHTML = '';
          const digits = String(target).split('');
          digits.forEach((d) => {
            const span = document.createElement('span');
            span.className = 'six-flip-digit';
            span.dataset.digit = d;
            span.textContent = d;
            c.appendChild(span);
          });
        });
      }

      /**
       * Digital flip counter — odometer style.
       * For each tick, animates rotateX(360deg) on each digit span and swaps
       * text content at mid-rotation (180deg) for a true card-flip feel.
       * Tick cadence: ~80ms per increment. Total duration scales with target.
       */
      _animateFlipCounter(container) {
        if (container.dataset.played) return;
        container.dataset.played = '1';
        const target = parseInt(container.dataset.target, 10) || 0;
        if (target <= 0) return;

        // Build digit spans matching target's digit count.
        const digitCount = String(target).length;
        container.innerHTML = '';
        const digitSpans = [];
        for (let i = 0; i < digitCount; i++) {
          const span = document.createElement('span');
          span.className = 'six-flip-digit';
          span.dataset.digit = '0';
          span.textContent = '0';
          container.appendChild(span);
          digitSpans.push(span);
        }

        const startDelay = 500;
        const tickInterval = Math.max(40, Math.min(120, Math.round(2400 / target)));
        let current = 0;

        const setDigits = (value) => {
          const valStr = String(value).padStart(digitCount, '0');
          for (let i = 0; i < digitCount; i++) {
            const span = digitSpans[i];
            const newDigit = valStr[i];
            if (span.dataset.digit !== newDigit) {
              span.classList.remove('is-flipping');
              // Force reflow so animation restarts cleanly
              void span.offsetWidth;
              span.classList.add('is-flipping');
              // Swap text content at midpoint of rotation (180deg -> 120ms in)
              setTimeout(() => {
                span.textContent = newDigit;
                span.dataset.digit = newDigit;
              }, 120);
              setTimeout(() => {
                span.classList.remove('is-flipping');
              }, 240);
            }
          }
        };

        const tick = () => {
          if (current >= target) {
            setDigits(target);
            return;
          }
          current += 1;
          setDigits(current);
          setTimeout(tick, tickInterval);
        };

        setTimeout(tick, startDelay);
      }
    });
  }

  if (!window.__sixthSlideshowEditorBound) {
    window.__sixthSlideshowEditorBound = true;

    document.addEventListener('shopify:block:select', (e) => {
      const slideshow = e.target.closest('sixth-hero-slideshow') || e.target.querySelector('sixth-hero-slideshow');
      const slide = e.target.classList && e.target.classList.contains('six-slide') ? e.target : e.target.querySelector('.six-slide');
      if (slideshow && slide) {
        const idx = parseInt(slide.dataset.index, 10);
        slideshow.stopAutoplay();
        slideshow.goTo(idx);
      }
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      const slideshow = e.target.closest('sixth-hero-slideshow') || (e.target.querySelector && e.target.querySelector('sixth-hero-slideshow'));
      if (slideshow && slideshow.autoplay && !slideshow.reducedMotion) slideshow.startAutoplay();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
